import { Button, Text } from '@medly-components/core';
import { CloseIcon } from '@medly-components/icons';
import styled, { css } from 'styled-components';
import { ReactComponent as ShortLogo } from '../Logo/ShortLogo.svg';
import { Position } from './types';

export const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
`;

const getArrowPosition = ({ position }: { position: Position }) => {
    switch (position) {
        case 'top':
            return css`
                transform: translateX(-50%);
                top: 100%;
                left: 50%;
            `;
        case 'bottom':
            return css`
                transform: translateX(-50%) rotate(180deg);
                left: 50%;
                bottom: 100%;
            `;
    }
};

export const tourDailogCommonStyles = css`
    width: 43.8rem;
    box-sizing: border-box;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    padding: 1.6rem;
    border-radius: 0.8rem;
    transition: all 0.4s ease;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 0.6rem 1.6rem rgba(0, 0, 0, 0.08), 0 0.3rem 0.6rem -0.4rem rgba(0, 0, 0, 0.12), 0 0.9rem 2.8rem 0.8rem rgba(0, 0, 0, 0.05);
`;

export const DialogBox = styled.div<{ position: Position }>`
    position: absolute;
    z-index: 2;
    ${tourDailogCommonStyles}

    &::after {
        content: '';
        width: 0;
        height: 0;
        z-index: 2;
        position: absolute;
        border-left: 0.8rem solid transparent;
        border-right: 0.8rem solid transparent;
        border-top: 1rem solid white;
        ${getArrowPosition}
    }

    ${Button.Style} {
        align-self: flex-end;
    }
`;

export const DialogBoxContent = styled.div`
    position: relative;

    & > div {
        max-width: calc(100% - 5.3rem);

        p {
            margin: 0;
        }
    }
`;

export const CloseButton = styled(CloseIcon).attrs({ size: 'M' })`
    position: absolute;
    top: 0;
    right: 0;
    * {
        fill: ${({ theme }) => theme.colors.darkBlue};
    }
`;

export const GuidedTourButton = styled(ShortLogo)`
    cursor: pointer;
    position: fixed;
    bottom: 4rem;
    right: 4rem;
    width: 3.2rem;
    height: 3.2rem;
    padding: 1.2rem;
    z-index: 1;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.darkBlue};
    * {
        fill: ${({ theme }) => theme.colors.white};
    }
`;

export const TourStepper = styled(Text)`
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.grey[700]};
    margin-bottom: 0.2rem;
    max-width: calc(100% - 2.4rem);
`;

export const TourHeader = styled(Text).attrs({ textVariant: 'body1', textWeight: 'Medium' })`
    display: block;
    margin-bottom: 0.8rem;
    max-width: calc(100% - 2.4rem);
`;
